<template>
  <v-layout column align-center justify-center mt-2 style = 'user-select: none;'>
    <v-slide-x-transition key = '0' v-show = 'true'>
      <v-container fluid class='py-0 mb-2' v-if = 'true' style = 'width: 75%;'>
        <v-layout d-flex row wrap class = 'my-2 pa-4 title font-weight-light' style = 'margin: auto; box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.8); border-radius: 4px; background: white;'>
          <v-layout column :style = '$vuetify.breakpoint.smAndUp? "max-width: calc(100% - 341px);" : ""' class = 'subtitle-1 font-weight-light'>
            <span class = 'display-3 mb-4'>Artics <span class = 'red--text text--darken-3'>Цифры</span></span>
            <ul style = 'list-style-type: none;'>
              <li><v-icon small left color = 'red accent-3'>mdi-check</v-icon>Забудьте о бесконечных переключениях между разными кабинетами и кипе листов в Excel</li>
              <li><v-icon small left color = 'red accent-3'>mdi-check</v-icon>Все ваши отчеты в одном интерфейсе</li>
              <li><v-icon small left color = 'red accent-3'>mdi-check</v-icon>На расстоянии пары кликов</li>
            </ul>
            <v-flex mt-5 d-flex :row = '!$vuetify.breakpoint.smAndUp' wrap align-end :style = '`width: ${$vuetify.breakpoint.smAndUp? "70":"100"}%;`'>
              <v-btn 
                depressed 
                :color = '$store.getters.uiAccent' 
                class = 'white--text px-5' 
                :block = '!$vuetify.breakpoint.smAndUp'
                href = 'tel:+7(495)-604-12-44'
                style = 'border-radius: 32px !important;'
              >Связаться с нами</v-btn>
              <v-btn 
                outlined 
                :class = '!$vuetify.breakpoint.smAndUp ? "mt-1 px-5": "ml-2 px-5"' 
                :color='$store.getters.uiAccent' 
                :block = '!$vuetify.breakpoint.smAndUp' 
                style = 'border-radius: 32px !important;'
                to = 'auth'
              >Войти</v-btn>
            </v-flex>
          </v-layout>
          <v-divider vertical class = 'my-5' v-if = '$vuetify.breakpoint.smAndUp'></v-divider>
          <v-layout column style = 'max-width: 340px;' align-start :class = '!$vuetify.breakpoint.smAndUp ? "mt-4": ""'>
            <v-layout wrap d-flex align-center justify-center>
              <v-flex
                v-for = "(item, i) in serviceLogos" :key = "i"
                xs6 md3
                d-flex
                align-center justify-center
              >
                <v-img 
                  class = 'ma-1'
                  :src = '`${require(`@/assets/logo-services/${item}.png`)}`' 
                  contain 
                  width = '42px' height = '42px'
                ></v-img>
              </v-flex>
            </v-layout>
            <span style = 'align-self: center' class = 'mt-3 subtitle-1 font-weight-light'>... и многое другое</span>
          </v-layout>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <v-slide-x-transition key = '1' v-show = 'true' mode = 'out-in' hide-on-leave>
      <v-container fluid class='py-0 mb-2' v-if = 'true' style = 'width: 75%;'>
        <v-layout my-2> 
          <v-card flat style = 'box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.8); border-radius: 4px; background-color: white;'>
            <v-card-title class = 'title font-weight-regular'>Нам доверяют</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap d-flex align-center justify-space-between px-12>
                <v-flex
                  v-for="(item, i) in clients" :key="i"
                  xs6 md2
                  d-flex
                  align-center justify-center
                >
                  <v-img 
                    class = 'my-1 mx-2'
                    :src = '`${require(`@/assets/clients/${item}.png`)}`' 
                    contain 
                    height = '100px'
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <v-slide-x-transition key = '2' v-show = 'true' mode = 'out-in' hide-on-leave>
      <v-container fluid class='py-0 mb-2' v-if = 'true' style = 'width: 75%;'>
        <v-layout my-2 :wrap = '!$vuetify.breakpoint.smAndUp'>
          <v-flex xs12 md6 :class = '$vuetify.breakpoint.smAndUp? "mr-3": ""'>
            <v-card flat style = 'box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.8); border-radius: 4px; background-color: white;'>
              <v-card-title class = 'title font-weight-regular'>Все данные в одном месте</v-card-title>
              <v-divider></v-divider>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' :style = '`border: 1px solid ${$store.getters.uiAccent};`'>
                  <v-icon size = '32' :color = '$store.getters.uiAccent'>mdi-monitor-dashboard</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Объединяйте рекламные кабинеты</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Система объединит в отчетах данные с любых рекламных кабинетов</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' :style = '`border: 1px solid ${$store.getters.uiAccent};`'>
                  <v-icon size = '32' :color = '$store.getters.uiAccent'>mdi-home-analytics</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Отслеживайте результативность</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Система автоматически сопоставит расходы с данными систем аналитики</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' :style = '`border: 1px solid ${$store.getters.uiAccent};`'>
                  <v-icon size = '32' :color = '$store.getters.uiAccent'>mdi-folder-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Оценивайте эффект для продукта</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Система подключится к вашей CRM-системе и отследит ключевые показатели</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' :style = '`border: 1px solid ${$store.getters.uiAccent};`'>
                  <v-icon size = '32' :color = '$store.getters.uiAccent'>mdi-gauge</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Контролируйте выполнение</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Система добавит медиапланы для оценки результативности</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-flex>
          <v-flex xs12 md6 :class = '$vuetify.breakpoint.smAndUp? "ml-3": "mt-4"'>
            <v-card flat style = 'box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.8); border-radius: 4px; background-color: white;'>
              <v-card-title class = 'title font-weight-regular'>Мониторинг аномалий</v-card-title>
              <v-divider></v-divider>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' style = 'border: 1px solid #1565C0;'>
                  <v-icon size = '32' color = 'blue darken-3'>mdi-av-timer</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Будьте в курсе событий</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Система анализурует данные в реальном времени и оповещает об аномалиях</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' style = 'border: 1px solid #1565C0;'>
                  <v-icon size = '32' color = 'blue darken-3'>mdi-bell-ring</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Влияйте на эффективность рекламы</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Настройте уведомления и оперативно принимайте решения</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' style = 'border: 1px solid #1565C0;'>
                  <v-icon size = '32' color = 'blue darken-3'>mdi-help</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Задавайте вопросы</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Специалисты поддержки предоставят подробные разъяснения</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item three-line>
                <v-list-item-avatar size = '64' style = 'border: 1px solid #1565C0;'>
                  <v-icon size = '32' color = 'blue darken-3'>mdi-check-decagram</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Доверяйте цифрам</v-list-item-title>
                  <v-list-item-subtitle class = 'font-weight-light'>Никакого сэмплирования или потери данных, будьте уверены в каждом рубле</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
    <v-slide-x-transition key = '3' v-show = 'true' mode = 'out-in' hide-on-leave>
      <v-container fluid class='py-0 mb-2' v-if = 'true' style = 'width: 75%;'>
        <v-layout my-2>
          <v-card flat style = 'width: 100%; box-shadow: 0px 0px 30px 2px rgba(217,217,217,0.8); border-radius: 4px; background-color: white;'>
            <v-card-title class = 'title font-weight-regular'>Цифры скажут о многом</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout column>
                <v-btn 
                  depressed  
                  to = 'auth'
                  :color = '$store.getters.uiAccent' 
                  class = 'my-3 mx-auto px-5 white--text' 
                  :block = '!$vuetify.breakpoint.smAndUp'
                  style = 'max-width: 360px; min-width: 320px; border-radius: 32px !important;'
                >Начать работу</v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-slide-x-transition>
  </v-layout>
</template>

<script>

  export default {
    data() {
      return {
        serviceLogos: ['ga', 'adobe-analytics', 'adjust', 'appmetrica', 'gads', 'gdv', 'ya', 'vk', 'fb', 'calltouch', 'callkeeper', 'yt'],
        clients: ['evalar', 'inchcape', 'homeme', 'tricolor']
      }
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
    beforeRouteEnter (to,from,next) {
      next(vm => {
        vm.$store.commit('disablePreloader');
      });
    }
  };
</script>